module.exports = __webpack_public_path__ + "static/media/leftarrow.eb3f1a8e.png";